import { render } from "./AccessOnTime.vue?vue&type=template&id=c63e3656"
import script from "./AccessOnTime.vue?vue&type=script&lang=js"
export * from "./AccessOnTime.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__